export const transitionDuration = 0.4;

export default {
  // Animation duration
  duration: transitionDuration,

  // Animation delay
  delay: {
    stagger: 0.1,
    stage_0: 0,
    stage_1: `${transitionDuration * 0.5}`,
    stage_2: `${transitionDuration * 0.75}`,
    stage_3: `${transitionDuration}`,
    stage_4: `${transitionDuration * 1.1}`,
    stage_5: `${transitionDuration * 1.3}`,
    stage_6: `${transitionDuration * 1.5}`,
    staggerLetters: 0.03,
  },

  offset: 100,
  parallaxDistance: 200,
  // Animation ready class
  readyClass: 'motion-ready',

  // Section Names
  section: '[data-animation="section"]',
  sectionEventStart: 'sectionEventStart',
  sectionEventStop: 'sectionEventStop',

  scrollToButton: '[data-role="scroll-down"]',
  scrollToTarget: '[data-role="scroll-to"]',

  // Section Items
  line: '[data-animation="line"]',
  number: '[data-animation="number"]',
  text: '[data-animation="text"]',
  eyebrow: '[data-animation="eyebrow"]',
  title: '[data-animation="title"]',
  titleWithLine: '[data-animation="title-with-line"]',
  img: '[data-animation="img"]',
  parallaxImageContainer: '[data-animation="parallax-img"]',
  parallaxDefaultContainer: '[data-animation="parallax-default"]',
  parallaxItem: '[data-animation="parallax-item"]',
  fadeIn: '[data-animation="fade-in"]',
  fadeInUp: '[data-animation="fade-in-up"]',
  fadeInUpText: '[data-animation="fade-in-up_text"]',
  fadeInDown: '[data-animation="fade-in-down"]',
  fadeInRight: '[data-animation="fade-in-right"]',
  fadeInLeft: '[data-animation="fade-in-left"]',
  linkWithIcon: '[data-animation="link-with-icon"]',

  // Extra
  letter: '[class*=char]',
  counterNumber: '[data-animation="number"]',
  word: '.word',
  icon: '[class^="icon-"]',

  // Additional items
  fadeSlider: '[data-role="fade-slider-container"]',
  fadeSlide: '[data-role="fade-slider-slide"]',
};



// WEBPACK FOOTER //
// ./scripts/animation/animation-selectors.js